var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9502 18.0333L6 13.082L7.64967 11.4323L10.9502 14.7317L17.5488 8.13184L19.1997 9.78267L10.9502 18.0333Z",
    fill: "#B39359"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.167969 13.0003C0.167969 5.91283 5.9138 0.166992 13.0013 0.166992C20.0888 0.166992 25.8346 5.91283 25.8346 13.0003C25.8346 20.0878 20.0888 25.8337 13.0013 25.8337C5.9138 25.8337 0.167969 20.0878 0.167969 13.0003ZM13.0013 23.5003C11.6224 23.5003 10.257 23.2287 8.98313 22.7011C7.70921 22.1734 6.5517 21.4 5.57668 20.4249C4.60167 19.4499 3.82824 18.2924 3.30057 17.0185C2.77289 15.7446 2.5013 14.3792 2.5013 13.0003C2.5013 11.6214 2.77289 10.2561 3.30057 8.98215C3.82824 7.70823 4.60167 6.55072 5.57668 5.5757C6.5517 4.60069 7.70921 3.82726 8.98313 3.29959C10.257 2.77192 11.6224 2.50033 13.0013 2.50033C15.7861 2.50033 18.4568 3.60657 20.4259 5.5757C22.3951 7.54484 23.5013 10.2156 23.5013 13.0003C23.5013 15.7851 22.3951 18.4558 20.4259 20.4249C18.4568 22.3941 15.7861 23.5003 13.0013 23.5003Z",
    fill: "#B39359"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.2e8ad735a02c307a8dc2dd0cca5c4996.svg";
export { ForwardRef as ReactComponent };